var map = {
	"./AXISBANK.BO.png": 4267,
	"./Bank-of-Baroda.png": 8984,
	"./bajaj.png": 6184,
	"./bank of maharashtra.png": 1964,
	"./canara bank.png": 9452,
	"./centralbank.png": 2849,
	"./fino.png": 5532,
	"./gayathri.png": 9368,
	"./hdfc.png": 9488,
	"./icici.png": 6448,
	"./idbi.png": 6388,
	"./idfc.png": 3956,
	"./induskand.png": 8184,
	"./kotak.png": 5248,
	"./logo-1.png": 2991,
	"./logo-10.png": 676,
	"./logo-11.png": 2936,
	"./logo-12.png": 9044,
	"./logo-13.png": 948,
	"./logo-14.png": 2212,
	"./logo-15.png": 8964,
	"./logo-16.png": 828,
	"./logo-2.png": 3620,
	"./logo-3.png": 856,
	"./logo-4.png": 2364,
	"./logo-5.png": 8788,
	"./logo-6.png": 6280,
	"./logo-7.png": 7068,
	"./logo-8.png": 5016,
	"./logo-9.png": 5504,
	"./logo-main.png": 9596,
	"./pnb.png": 6719,
	"./punjab national.png": 7424,
	"./rbl.png": 792,
	"./sbi.png": 8256,
	"./tatacapital.png": 1936,
	"./uco.png": 9813,
	"./unionbank.png": 4636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3896;